import React, {PropsWithChildren, useCallback, useState} from "react";
import Toast from "@app/component/overlays/toaster/Toast";
import Toaster from "@app/component/overlays/toaster/Toaster";
import _uniqueId from "lodash/uniqueId";
import ToasterContext from "@app/component/overlays/toaster/context/ToasterContext";

export const ToasterContextProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const [toasts, setToasts] = useState<Toast[]>([]);

    const addToast = (toast: Toast) => {
        setToasts((toasts) => [...toasts, toast]);
        setTimeout(() => setToasts((toasts) => toasts.slice(1)), 3000);
    }

    const removeToast = (index: number) => {
        setToasts([...toasts.slice(0, index), ...toasts.slice(index + 1)])
    }

    const info = (title: string, text: string) => {
        addToast({state: 'info', title: title, text: text})
    }
    const success = (title: string, text: string) => {
        addToast({state: 'success', title: title, text: text})
    }
    const error = (title: string, text: string) => {
        addToast({state: 'error', title: title, text: text})
    }
    return (
        <ToasterContext.Provider value={{info, success, error}}>
            {children}
            <div
                aria-live="assertive"
                className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
            >
                <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                    {toasts.map((toast, index) =>
                        <Toaster key={_uniqueId('toaster_')}
                                 index={index}
                                 toast={toast}
                                 onClose={() => removeToast(index)}/>
                    )}
                </div>
            </div>
        </ToasterContext.Provider>
    );
}

export default ToasterContextProvider;